import { AgentStatusEnum, SourceEnum } from 'types/enums'

export type AgentStatusOption = {
  label: string
  value: AgentStatusEnum | ''
}

export const AGENT_STATUS_OPTIONS: AgentStatusOption[] = [
  {
    label: 'tables.agents.filters.selectStatus',
    value: '',
  },
  {
    label: 'tables.agents.agentStatus.active',
    value: AgentStatusEnum.Active,
  },
  {
    label: 'tables.agents.agentStatus.inactive',
    value: AgentStatusEnum.Inactive,
  },
  {
    label: 'tables.agents.agentStatus.invalid',
    value: AgentStatusEnum.Invalid,
  },
]

export type AgentSourceOption = {
  label: string
  value: SourceEnum | ''
}

export const AGENT_SOURCE_OPTIONS: AgentSourceOption[] = [
  {
    label: 'tables.agents.filters.selectSource',
    value: '',
  },
  {
    label: 'enums.sources.NONE.base',
    value: SourceEnum.None,
  },
  {
    label: 'enums.sources.ESTATE_PLUS.base',
    value: SourceEnum.EstatePlus,
  },
  {
    label: 'enums.sources.FORTUNET.base',
    value: SourceEnum.Fortunet,
  },
  {
    label: 'enums.sources.ORBIT.base',
    value: SourceEnum.Orbit,
  },
  {
    label: 'enums.sources.REAL_STATUS.base',
    value: SourceEnum.RealStatus,
  },
  {
    label: 'enums.sources.ILIST.base',
    value: SourceEnum.IList,
  },
  {
    label: 'enums.sources.GOLDEN_HOME.base',
    value: SourceEnum.GoldenHome,
  },
  {
    label: 'enums.sources.ZOIA.base',
    value: SourceEnum.Zoia,
  },
]
